export default (settings: any) => settings['referenceFilter'] * (10 / 60)
